export interface SeedPhoto {
  readonly id: string;
  readonly at: number;
  readonly author: string;
  readonly width: number;
  readonly height: number;
}

export const COVER_ID = "c01";
export const MODERATION_TARGET = "c23";
export const DEMO_CODE = "DEMO2026";
export const DEFAULT_EVENT_NAME = "Casamento Leo & Day";

export const SEED: readonly SeedPhoto[] = [
  { id: "c02", at: 8, author: "Marta Lima", width: 819, height: 1024 },
  { id: "c03", at: 21, author: "Júlia Prado", width: 1024, height: 1024 },
  { id: "c04", at: 37, author: "Pedro Alves", width: 1024, height: 1024 },
  { id: "c06", at: 64, author: "Carlos Lima", width: 1024, height: 1024 },
  { id: "c07", at: 83, author: "Rafa Nunes", width: 1024, height: 1024 },
  { id: "c08", at: 101, author: "Bia Souza", width: 1024, height: 1024 },
  { id: "c09", at: 126, author: "Júlia Prado", width: 1024, height: 1024 },
  { id: "c10", at: 141, author: "Pedro Alves", width: 819, height: 1024 },
  { id: "c11", at: 158, author: "Bia Souza", width: 1024, height: 1024 },
  { id: "c12", at: 183, author: "Marta Lima", width: 1024, height: 1024 },
  { id: "c13", at: 196, author: "Rafa Nunes", width: 1024, height: 1024 },
  { id: "c14", at: 207, author: "Júlia Prado", width: 1024, height: 1024 },
  { id: "c15", at: 219, author: "Carlos Lima", width: 819, height: 1024 },
  { id: "c23", at: 228, author: "Pedro Alves", width: 1024, height: 1024 },
  { id: "c16", at: 241, author: "Bia Souza", width: 1024, height: 1024 },
  { id: "c17", at: 248, author: "Rafa Nunes", width: 1024, height: 1024 },
  { id: "c27", at: 255, author: "Marta Lima", width: 1024, height: 1024 },
];

export function seedSrc(id: string, size: "l" | "s"): string {
  return `/assets/demo/${id}-${size}.webp`;
}

export function formatCode(code: string): string {
  return code.replace(/(.{4})(?=.)/g, "$1 ");
}

export const SAMPLE_IDS: readonly string[] = ["c10", "c12", "c09"];
